import React from "react";
import LoginPage from '../pages/LoginPage';
import InvoiceTable from "../pages/invoice/InvoiceTable";
import InvoiceDetail from "../pages/invoice/InvoiceDetail";
import CustomerTable from "../pages/customer/CustomerTable";
import DomainProfileTable from "../pages/customer/DomainProfileTable";
import DomainProfileDetail from "../pages/customer/DomainProfileDetail";
import EditDomainProfileForm from "../pages/customer/EditDomainProfileForm";
import ServicePage from "../pages/services/ServicePage";
import TicketTable from "../pages/ticket/TicketTable";
import TicketDetail from "../pages/ticket/TicketDetail";
import ProductTable from "../pages/manage/ProductTable";
import CustomerDetail from "../pages/customer/CustomerDetail";
import VATBillRequestTable from "../pages/invoice/VATBillRequestTable";
import AgencySalesReport from "../pages/report/AgencySalesReport";
import InvoiceRelatedTable from "../pages/report/InvoiceRelatedTable";
import InvoiceWrongPriceTable from "../pages/report/InvoiceWrongPriceTable";
import DomainTracking from "../pages/services/DomainTracking";
import BillingTable from "../pages/billing/BillingTable";
import HistoryPage from "../pages/history/HistoryPage";
import InvoiceDebtTable from "../pages/invoice/InvoiceDebtTable";
import DCServerTable from "../pages/manage/DCServerTable";
import TicketRateReport from "../pages/report/TicketRateReport";
import SdnsConfigPage from "../pages/services/SdnsConfigPage";
import BillingInvoiceTable from "../pages/billing/BillingInvoiceTable";
import VPSManagePage from "../pages/services/VPSManagePage";
import MobileVersionTable from "../pages/mobile_version/MobileVersionTable";
import SaleCommissionReport from "../pages/report/SaleCommissionReport";

export const routes = [
  {
    path: "/admin/invoice/:invoiceStatus?/payment-method/:paymentMethod?",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/invoice_debt/:paymentMethod?",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDebtTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/invoice/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/invoice/agency/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={true} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/invoice/vat_request/:vat_status?",
    exact: true,
    render: (routeProps) => {
      return (
        <VATBillRequestTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/customer/:customer_type?",
    exact: true,
    render: (routeProps) => {
      return (
        <CustomerTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/customer/detail/:customer_id",
    exact: true,
    render: (routeProps) => {
      return (
        <CustomerDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/customer/profile/list",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/customer/profile/detail/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/customer/profile/edit/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <EditDomainProfileForm routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/service/search/all/:searchValue?",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage title="Tìm Kiếm Dịch Vụ" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/running",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="running" title="Dịch Vụ Đang Sử Dụng" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/pending",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="pending" title="Dịch Vụ Pending" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/expired",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="expired" title="Suspend do hết hạn" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/suspend",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="suspend" title="Suspend do vi phạm" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/deleted",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="deleted" title="Đã xoá" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/service/domain/tracking",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainTracking routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/ticket/:ticket_status?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketTable routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/ticket/detail/:ticket_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketDetail routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/admin/product/list",
    exact: true,
    render: (routeProps) => {
      return <ProductTable routeProps={routeProps} />
    }
  },
  {
    path: "/admin/report/agency/average/list",
    exact: true,
    render: (routeProps) => {
      return (
        <AgencySalesReport routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/admin/agency/average/related/invoice/:customer_id?/year/:year?",
    exact: true,
    render: (routeProps) => {
      return <InvoiceRelatedTable routeProps={routeProps} />
    }
  },
  {
    path: "/admin/report/invoice/wrong/price/list",
    exact: true,
    render: (routeProps) => {
      return <InvoiceWrongPriceTable routeProps={routeProps} />
    }
  },
  {
    path: "/admin/service/history/:user_product_id",
    exact: true,
    render: (routeProps) => {
      return (
        <HistoryPage title={"Lịch sử tương tác dịch vụ"} routeProps={routeProps} />
      )
    }
  },
  {
    path: "/admin/invoice/history/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <HistoryPage title={"Lịch sử tương tác đơn hàng"} routeProps={routeProps} />
      )
    }
  },
  {
    path: "/admin/billing/:account_type?",
    exact: true,
    render: (routeProps) => {
      return (
        <BillingTable routeProps={routeProps} />
      )
    }
  },
  {
    path: "/admin/billing-invoice/type/:type?/status/:status?",
    exact: true,
    render: (routeProps) => {
      return (
        <BillingInvoiceTable routeProps={routeProps} />
      )
    }
  },
  {
    path: "/admin/server/list",
    exact: true,
    render: (routeProps) => {
      return <DCServerTable routeProps={routeProps} />
    }
  },
  {
    path: "/admin/report/ticket_score/list",
    exact: true,
    render: (routeProps) => {
      return <TicketRateReport routeProps={routeProps} />
    }
  },
  {
    path: "/admin/sdns/config/:user_product_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <SdnsConfigPage routeProps={routeProps} />
      )
    }
  },
  // {
  //   path: "/admin/vps/config/:user_product_id?",
  //   exact: true,
  //   render: (routeProps) => {
  //     return (
  //       <VPSManagePage routeProps={routeProps} />
  //     )
  //   }
  // },
  {
    path: "/admin/mobile_version/all",
    exact: true,
    render: (routeProps) => {
      return (
        <MobileVersionTable routeProps={routeProps} />
      )
    }
  }
  // {
  //   path: "/admin/ip-address/list",
  //   exact: true,
  //   render: (routeProps) => {
  //     return <IpAddressTable routeProps={routeProps} />
  //   }
  // },
  // {
  //   path: "/admin/email-template/list",
  //   exact: true,
  //   render: (routeProps) => {
  //     return <EmailTemplateTable routeProps={routeProps} />
  //   }
  // },
  // {
  //   path: "/admin/supplier/list",
  //   exact: true,
  //   render: (routeProps) => {
  //     return <SupplierTable routeProps={routeProps} />
  //   }
  // },
  // {
  //   path: "/admin/bank/list" ,
  //   exact: true,
  //   render: (routeProps) => {
  //     return <BankTable routeProps={routeProps} />
  //   }
  // },
  // {
  //   path: "/admin/campaign/list",
  //   exact: true,
  //   render: (routeProps) => {
  //     return <CampaignTable routeProps={routeProps} />
  //   }
  // },
];

export const supportRoutes = [
  {
    path: "/support/invoice/:invoiceStatus?/payment-method/:paymentMethod?",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support/invoice/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support/ticket/:ticket_status?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketTable routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support/ticket/detail/:ticket_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketDetail routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support/customer/profile/list",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support/customer/profile/detail/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support/customer/profile/edit/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <EditDomainProfileForm routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support/service/running",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="running" title="Dịch Vụ Đang Sử Dụng" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support/service/pending",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="pending" title="Dịch Vụ Pending" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support/sdns/config/:user_product_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <SdnsConfigPage routeProps={routeProps} />
      )
    }
  },
  {
    path: "/support/vps/config/:user_product_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <VPSManagePage routeProps={routeProps} />
      )
    }
  }
]; 

export const supportLeaderRoutes = [
  {
    path: "/support-leader/invoice/:invoiceStatus?/payment-method/:paymentMethod?",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support-leader/invoice/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support-leader/ticket/:ticket_status?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketTable routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support-leader/ticket/detail/:ticket_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <TicketDetail routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support-leader/customer/profile/list",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support-leader/customer/profile/detail/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support-leader/customer/profile/edit/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <EditDomainProfileForm routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/support-leader/service/running",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="running" title="Dịch Vụ Đang Sử Dụng" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support-leader/service/pending",
    exact: true,
    render: (routeProps) => {
      return (
        <ServicePage service_status="pending" title="Dịch Vụ Pending" routeProps={routeProps}/>
      )
    }
  },
  {
    path: "/support-leader/report/ticket_score/list",
    exact: true,
    render: (routeProps) => {
      return <TicketRateReport routeProps={routeProps} />
    }
  },
  {
    path: "/support-leader/sdns/config/:user_product_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <SdnsConfigPage routeProps={routeProps} />
      )
    }
  },
  {
    path: "/support-leader/service/history/:user_product_id",
    exact: true,
    render: (routeProps) => {
      return (
        <HistoryPage title={"Lịch sử tương tác dịch vụ"} routeProps={routeProps} />
      )
    }
  },
  {
    path: "/support-leader/vps/config/:user_product_id?",
    exact: true,
    render: (routeProps) => {
      return (
        <VPSManagePage routeProps={routeProps} />
      )
    }
  }
]; 

export const saleRoutes = [
  {
    path: "/sale/customer/:customer_type?",
    exact: true,
    render: (routeProps) => {
      return (
        <CustomerTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/sale/customer/detail/:customer_id",
    exact: true,
    render: (routeProps) => {
      return (
        <CustomerDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/sale/invoice/:invoiceStatus?/payment-method/:paymentMethod?",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/sale/invoice/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/sale/commission/report",
    exact: true,
    render: (routeProps) => {
      return (
        <SaleCommissionReport is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
];

export const accountantRoutes = [
  {
    path: "/accounting/invoice/vat_request/:vat_status?",
    exact: true,
    render: (routeProps) => {
      return (
        <VATBillRequestTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/accounting/invoice/detail/:invoice_id",
    exact: true,
    render: (routeProps) => {
      return (
        <InvoiceDetail is_agency_invoice={false} routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/accounting/customer/profile/list",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileTable routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/accounting/customer/profile/detail/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <DomainProfileDetail routeProps = {routeProps} />
      )
    }
  },
  {
    path: "/accounting/customer/profile/edit/:domain_profile_id",
    exact: true,
    render: (routeProps) => {
      return (
        <EditDomainProfileForm routeProps = {routeProps} />
      )
    }
  },
];

export const loginRoutes = [
  {
    path: "/",
    exact: true,
    render: () => {
      return (
        <LoginPage/>
      )
    }
  }
];
